import { POST, GET, ApiError, resolveApiPath } from "./utils";

// 60 second timeout for workflow creation (includes uploading frames to dataset)
const WORKFLOW_CREATION_TIMEOUT_MS = 60 * 1000;

export const createRapidWorkflow = async (data: any) => {
    return await POST("/api/workflow", data, { timeoutMs: WORKFLOW_CREATION_TIMEOUT_MS });
};

export const getRapidWorkflow = async (workflowUrl: string, workspaceId: string) => {
    return await GET(`/api/workflow/${workflowUrl}?workspaceId=${workspaceId}`);
};

export const getRapidHydration = async (rapidDataId: string) => {
    // Inline fetch (rather than shared GET helper) so we can read the
    // error body on !ok and surface the structured `code` field — the
    // hydrate component needs to tell a WORKFLOW_ORPHANED 404 apart from
    // a real RapidData-not-found or permission error.
    const workspaceUrl = window.location.pathname.split("/")[1] || "";
    const params = workspaceUrl ? `?workspaceUrl=${encodeURIComponent(workspaceUrl)}` : "";
    const response = await fetch(resolveApiPath(`/api/rapiddata/${rapidDataId}/hydrate${params}`), {
        credentials: "include"
    });

    if (!response.ok) {
        let errorBody: { error?: string; code?: string; [key: string]: unknown } = {};
        try {
            errorBody = await response.json();
        } catch {
            // body wasn't JSON — ignore
        }
        throw new ApiError(
            errorBody.error || response.statusText || "Failed to hydrate rapid project",
            response.status,
            errorBody.code,
            errorBody
        );
    }

    return response.json();
};

export const getPublicRapidWorkflowBySlug = async (shareableSlug: string) => {
    return await GET(`/api/workflow/public/${shareableSlug}`);
};

export const getWorkflowToken = async (workflowId: string, workspaceId: string) => {
    return await GET(`/query/workflow/token?workflowId=${workflowId}&workspaceId=${workspaceId}`);
};

export const getPublicRapidData = async (rapidDataId: string) => {
    return await GET(`/api/rapiddata/public/${rapidDataId}`);
};

export const getWorkspaceRapidModels = async (workspaceId: string) => {
    return await GET(`/api/workspace/${workspaceId}/models`);
};

export const saveWorkflowFromTemplate = async (
    workspaceId: string,
    workflow: { name: string; url: string; template: string; config: string }
) => {
    return await POST("/query/workflow/save", { workspaceId, workflow });
};
